import React from "react";
import { Link } from "react-router-dom";

import {
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter,
} from "mdbreact";

function ModalAvertissement(props) {
  const showAvertissement = props.showAvertissement;
  const setShowAvertissement = props.setShowAvertissement;

  const handleClose = () => setShowAvertissement(false);

  return (
    <MDBModal isOpen={showAvertissement} size="lg" onHide={handleClose}>
      <MDBModalHeader>Connexion requise</MDBModalHeader>
      <MDBModalBody>
        Vous devez <Link to="/signup">créer un compte</Link> ou{" "}
        <Link to="/login">vous connecter</Link> pour pouvoir utiliser cette
        fonctionnalité.
      </MDBModalBody>
      <MDBModalFooter>
        <MDBBtn color="primary" onClick={handleClose}>
          OK
        </MDBBtn>
      </MDBModalFooter>
    </MDBModal>
  );
}

export default ModalAvertissement;
